


import styled from "styled-components"
import InputText from "../shared/input/new/InputText"
import { useEffect, useState } from "react"
import InputTextarea from "../shared/input/new/InputTextarea"
import InputSelect from "../shared/input/new/InputSelect"
import { sendOptions } from '../../utils/bildirimOptions'
import Btn from "../shared/button/Btn"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { IoCloseCircleOutline } from "react-icons/io5";
import SmallSpinner from "../shared/spinners/SmallSpinner"
import PortalBildirimMainMenuInput from "../shared/input/special/PortalBildirimMainMenuInput"
import PortalBildirimSubMenuInput from "../shared/input/special/PortalBildirimSubMenuInput"
import { mainMenuOptions } from "../../utils/portalBildirimOptions"
import { getAdminCompanyLoadFilter } from "../../features/loadList/loadListSlice"
import BildirimFirmaInput from "../shared/input/special/BildirimFirmaInput"
import { sendPortalNotificationSpecific, setNotificationMenuPortal, setNotificationSubMenuPortal, setNotificationTextPortal, setNotificationTitlePortal, setSelectedCompanyList } from "../../features/admin4/admin4Slice"
import RegularMonthSelectPortalContainer from "./RegularMonthSelectPortalContainer"
import RegularWeekSelectPortalContainer from "./RegularWeekSelectPortalContainer"
import TargetDateNotificationPortalContainer from "./TargetDateNotificationPortalContainer"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    .main-content-container{
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        gap: 50px;
    }

    .input-side{
        display: flex;
        flex-direction: column;
        gap: 20px;

    }
    .list-side{
        display: flex;
        flex-direction: column;
        gap: 10px;

        .company-item{
            display: flex;
            align-items: center;
            gap: 10px;
            .delete-icon{
                cursor: pointer;
                font-size: 1.2rem;
            }
            .company-name{
                padding: 8px;
                width: max-content;
                border: 1px solid var(--color-main);
                border-radius: 10px;
                color: var(--color-main);
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                display: flex;
                align-items: center;
                gap: 5px;
                cursor: pointer;

            }
        }

    }
    .process-seperator{
        width: 100%;
        background-color: ${({theme}) => theme.mainBorderColor};
        height: 1px;
    }

    .extra-content-container{
        display: flex;
        margin: 20px 0;
        gap: ${({selectedSendType}) => selectedSendType ? "50px" : 0} ;

        .select-side{

        }

        .select-result-side{
            display: flex;
            flex-direction: column;

    
        }
    }

`

const SendNotificationSpecificPortalUser = () => {

    const dispatch = useDispatch()

    const {
        selectedCompanyList,
        notificationMenuPortal,
        notificationSubMenuPortal,
        notificationTextPortal,
        notificationTitlePortal,
        isLoadingSendPortalNotificationSpecific
    } = useSelector(state => state.admin4)

    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const rld = JSON.parse(storage.getItem("rld"))
    const { loadListCompanyList  } = useSelector((state) => state.loadList);
    
    useEffect(() => {
    if(rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01" || rld === "f84f35ab-0eb1-46a4-84f4-e72b236c3d26" || rld === "a7b53ef7-1cf6-4720-9b13-d9f81b5a0f99"){
        dispatch(getAdminCompanyLoadFilter())
    }
    },[])

    const [selectedSendType, setSelectedSendType] = useState({
        id:null,
        text: ""
    })


    const handleClickNow = () => {
        if(notificationTitlePortal && notificationTextPortal && notificationMenuPortal?.value && selectedCompanyList?.length > 0){
            dispatch(sendPortalNotificationSpecific({
                text: notificationTextPortal,
                title: notificationTitlePortal,
                route: notificationMenuPortal.value,
                altRoute: notificationSubMenuPortal.value,
                scheduledNotificationRecipients: selectedCompanyList.map(item => {
                    return {
                        companyId: item.companyId
                    }
                })
            }))
        }
    }


  return (
    <Container  selectedSendType={selectedSendType.id !== null}>
        <div className="main-content-container">
        <div className="input-side">
            <InputText data={notificationTitlePortal} setData={(e) => dispatch(setNotificationTitlePortal(e.target.value))} labelText="Bildirim Başlığı" inputWidth={"350px"} name={"title"}/>
            <InputTextarea data={notificationTextPortal} setData={(e) => dispatch(setNotificationTextPortal(e.target.value))} labelText={"Bildirim Metni"}  inputWidth={"350px"} name={"content"}/>
            <PortalBildirimMainMenuInput data={notificationMenuPortal?.text} setData={(data) => dispatch(setNotificationMenuPortal({item:data, pastNotificationMenuPortal:notificationMenuPortal}))} initialOptions={mainMenuOptions} labelText={"Menü"} inputWidth={"350px"} name={"menu"}/>
            <PortalBildirimSubMenuInput data={notificationSubMenuPortal?.text} setData={(data) => dispatch(setNotificationSubMenuPortal(data))} initialOptions={notificationMenuPortal?.subMenus || []} labelText={"Alt Menü"} inputWidth={"350px"} name={"subMenu"}/>
        </div>

        <div className="list-side">
            <BildirimFirmaInput data={selectedCompanyList} setData={(data) => dispatch(setSelectedCompanyList(data))} labelText={"Firmalar"} inputWidth={"300px"} initialOptions={loadListCompanyList} name={"selectedCompany"}  />
            {selectedCompanyList?.map((item) => (
                <div className="company-item">
                    <IoCloseCircleOutline onClick={() => dispatch(setSelectedCompanyList(selectedCompanyList.filter(filter=> filter.id !== item?.id)))} className="delete-icon"/>
                    <div className="company-name">{item.companyName}</div>
                </div>
            ))}
        </div>
        </div>
        <div className="process-seperator"/>
        <div className="extra-content-container">
            <div className="select-side">
                <InputSelect data={selectedSendType?.text} setData={(item) => setSelectedSendType(item)} initialOptions={sendOptions} labelText={"Gönderim Tipi Seçiniz"} inputWidth={"350px"} name={"sendOptions"}/>
            </div>
            <div className="select-result-side">

                {
                    selectedSendType.id === 0 &&
                    <RegularMonthSelectPortalContainer isAll={false}/>
                }

                {
                    selectedSendType.id === 1 &&
                    <RegularWeekSelectPortalContainer isAll={false}/>
                }

                {
                    selectedSendType.id === 2 &&
                    <TargetDateNotificationPortalContainer isAll={false}/>
                }

                {
                    selectedSendType.id === 3 &&
                    <Btn handleClick={handleClickNow} bgColor="#E85546" color="#fff" width={"350px"}>{isLoadingSendPortalNotificationSpecific ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Gönder"}</Btn>
                }
            </div>
        </div>
    </Container>
  )
}

export default SendNotificationSpecificPortalUser